/** Minimum password length enforced by datagon for every user-set password. */
export const MIN_PASSWORD_LENGTH = 8;

export const MIN_PASSWORD_LENGTH_MESSAGE = `Password must be at least ${MIN_PASSWORD_LENGTH} characters long`;

export const minPasswordLengthRule = {
  message: MIN_PASSWORD_LENGTH_MESSAGE,
  min: MIN_PASSWORD_LENGTH,
};
